import Swiper from 'swiper';
import Clipboard from 'clipboard';
import iziToast from "izitoast";
import { Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import * as UC from 'https://cdn.jsdelivr.net/npm/@uploadcare/file-uploader@1/web/uc-file-uploader-minimal.min.js';
import uk from 'https://cdn.jsdelivr.net/npm/@uploadcare/file-uploader@v1/locales/file-uploader/uk.js';


//* Cкрипт для переключения языка сайта
// const toggleLanguageButtons = () => {
//   const langButtons = document.querySelectorAll('.language-btn'); // Получаем все кнопки с классом 'language-btn'
  
//   langButtons.forEach(button => { // Для каждой кнопки выполняем
//     if (window.innerWidth < 1440) {
//       button.style.display = 'none'; // Скрыть кнопки на экранах меньше 1440px
//     } else {
//       button.style.display = 'flex'; // Показать кнопки на экранах 1440px и выше
//     }
//   });
// }


document.querySelector('.ua').addEventListener('click', () => {
    localStorage.setItem('language', 'ua');
    window.location.href = '/ua/';
});
document.querySelector('.ua-modal').addEventListener('click', () => {
    localStorage.setItem('language', 'ua');
    window.location.href = '/ua/';
});
document.querySelector('.en').addEventListener('click', () => {
    localStorage.setItem('language', 'en');
    window.location.href = '/en/';
});
document.querySelector('.en-modal').addEventListener('click', () => {
    localStorage.setItem('language', 'en');
    window.location.href = '/en/';
});
// При загрузке страницы проверяем, какой язык был выбран в localStorage и перенаправляем
document.addEventListener('DOMContentLoaded', () => {
    const lang = localStorage.getItem('language') || 'ua';


    // Скрываем кнопку для другого языка и отображаем текущую
    const uaButton = document.querySelector('.ua');
    const enButton = document.querySelector('.en');
    const uaButtonModal = document.querySelector('.ua-modal');
    const enButtonModal = document.querySelector('.en-modal');

  if (lang === 'ua') {
    uaButtonModal.style.display = 'none';
    enButtonModal.style.display = 'flex';

        if (window.innerWidth < 1440) {
          uaButton.style.display = 'none';
    enButton.style.display = 'none'      // Скрыть кнопки на экранах меньше 1440px
  } else {
            // Если выбран украинский, скрываем кнопку для английского
        uaButton.style.display = 'none';
        enButton.style.display = 'flex';
  }

        if (window.location.pathname !== '/ua/') {
            window.location.href = '/ua/';
        }
  } else {
        uaButtonModal.style.display = 'flex';
        enButtonModal.style.display = 'none';

    if (window.innerWidth < 1440) {
      uaButton.style.display = 'none';
      enButton.style.display = 'none';
    } else {
        uaButton.style.display = 'flex';
        enButton.style.display = 'none';
    }
        // Если выбран английский, скрываем кнопку для украинского

        if (window.location.pathname !== '/en/') {
            window.location.href = '/en/';
        }
  }
});


//* Cкрипт для слайдера карточек
// Функция для инициализации слайдера
const initSwiperInstance = (selector, options) => new Swiper(selector, options);

// Функция для инициализации первого слайдера с учетом ширины экрана
const initSwiper = () => {
  if (window.innerWidth < 1440) {
    if (!window.swiper) { // Если слайдер ещё не был инициализирован
      window.swiper = initSwiperInstance('.swiper-first', {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1,
        keyboard: { enabled: true },
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        modules: [Pagination, Mousewheel, Keyboard],
        breakpoints: {
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2, loop: false },
        },
      });
    }
  } else {
    // Уничтожаем слайдер на больших экранах
    if (window.swiper) {
      window.swiper = null;
    }
  }
}

// Инициализация второго слайдера (не требует ресайза)
let swiperSecond;

const initSwiperSecond = () => {
  if (!swiperSecond) { // Проверка на инициализацию слайдера
    swiperSecond = initSwiperInstance('.swiper-container', {
      loop: true,
      spaceBetween: 16,
      slidesPerView: 1,
      keyboard: { enabled: true },
      pagination: {
        el: '.swiper-pagination', // Уникальная пагинация для второго слайдера
        clickable: true,
      },
      modules: [Pagination, Keyboard],
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 1 },
        1440: { slidesPerView: 2, spaceBetween: 30, loop: true },
      },
    });
  }
}
// Инициализация первого слайдера при загрузке страницы
initSwiper();

// Перезапуск слайдера при изменении размера экрана
window.addEventListener('resize', initSwiper);

// Инициализация второго слайдера при загрузке страницы
initSwiperSecond();



//* Cкрипт для переворачивания карточек
const cards = document.querySelectorAll('.flip-card');
const isMobile = () => window.innerWidth < 769;

const handleCardFlip = (card) => {
  const innerCard = card.querySelector('.flip-card-inner');
  innerCard.classList.toggle('flipped');
};
const onCardClick = (event) => handleCardFlip(event.currentTarget);

if (isMobile()) {
  cards.forEach(card => card.addEventListener('click', onCardClick));
}


//* Cкрипт для открытия и закрытия модальных меню
const openModalButtons = document.querySelectorAll('.open-modal');
const modals = document.querySelectorAll('.backdrop');
const closeModalButtons = document.querySelectorAll('.close');
const submitButton = document.querySelector('.modal-sholorship-holders-submit');

openModalButtons.forEach(button => {
  button.addEventListener('click', () => {
    const modalId = button.getAttribute('data-target');
    const modal = document.getElementById(modalId);
    modal.classList.add('is-open');
    const container = modal.querySelector(".menu-modal-sholorship-holders-container");
    if (container) {
container.classList.add("active");
    }
    const campsContaner = modal.querySelector('.camps-modal-container');
    if (campsContaner) {
      campsContaner.classList.add('active');
    }    
    const donateContaner = modal.querySelector('.donate-modal-container');
    if (donateContaner) {
      donateContaner.classList.add('active');
    }  
  });
});

closeModalButtons.forEach(button => {
  button.addEventListener('click', () => {
    const modalId = button.getAttribute('data-modal');
    const modal = document.getElementById(modalId);
    modal.classList.remove('is-open');
    const containerSholorship = modal.querySelector(".menu-modal-sholorship-holders-container");
    const containerCamps = modal.querySelector(".camps-modal-container");
    const containerDonate = modal.querySelector(".donate-modal-container");
    if (containerSholorship) {
      containerSholorship.classList.remove("active");
    }
    if (containerCamps) {
      containerCamps.classList.remove("active");
    }
    if (containerDonate) {
      containerDonate.classList.remove("active");
    }
  });
});

// Закрытие модального окна при клике вне области модального окна
document.addEventListener('click', event => {
  modals.forEach(modal => {
    if (event.target === modal) {
      modal.classList.remove('is-open');
    }
  });
});

document.querySelectorAll('.menu-modal-link').forEach(link => {
  link.addEventListener('click', event => {
    event.preventDefault();
    const modal1 = document.getElementById('modal1');
    modal1.classList.remove('is-open');
    const sectionId = link.getAttribute('href');
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  });
});



submitButton.addEventListener('click', () => {
  const secondModal = document.getElementById('modal2');
  const form = document.querySelector('.js-modal-sholorship-holders-form');
  if (secondModal && form && form.checkValidity()) {
    secondModal.classList.remove('is-open');
    
    const container = secondModal.querySelector(".menu-modal-sholorship-holders-container");
    if (container) {
      container.classList.remove("active");
    }
  }
});


  //* Cкрипт для модального меню про степендиатов: отправка видео
// Инициализация компонента Uploadcare

UC.defineComponents(UC); 

  
const ctx = document.querySelector('uc-upload-ctx-provider');
const langAddVideo = document.documentElement.lang; // Получаем текущий язык сайта
    if (langAddVideo === 'uk') {
  UC.defineLocale('uk', uk);
    } 

ctx.addEventListener('file-upload-success', e => {
  const fileUrl = e.detail.cdnUrl;
  const fileUrlInput = document.querySelector('[name="videoUrl"]');
    if (fileUrlInput) {
          fileUrlInput.value = fileUrl;
    } else {
          console.log('Hidden input field not found.');
    }

  })


//* Cкрипт для отображения инфо, когда кемпов нет
const campsButton = document.querySelectorAll('.camps-country-button');
campsButton.forEach(button => {
  if (button.hasAttribute('disabled')) {
    button.parentElement.addEventListener('click', () => {
    iziToast.info({
        position: 'topRight',
        message: "Зараз немає доступних кемпів (There are currently no camp available)",
        timeout: 3000,
      });
})}
})

//* Cкрипт для подсвечивания карточек в кемпах
let selectedCard = null;

document.querySelectorAll('.camps-card').forEach(card => {
  card.addEventListener('click', function() {
    // Убираем подсветку с предыдущей карточки, если она была
    selectedCard?.classList.remove('selected');
    // Подсвечиваем текущую карточку
    selectedCard = card;
    card.classList.add('selected');
  });
});


//* Cкрипт для перехода на гугл-форму по кемпу
document.querySelectorAll('.js-camps-modal-button').forEach(button => {button.addEventListener('click', function() {
  
  if (selectedCard) {
    const formUrlCamp = selectedCard.getAttribute('data-form-url');
    
    // Проверяем, существует ли URL и не пустой ли он
    if (formUrlCamp && formUrlCamp.trim() !== '') {
      window.open(formUrlCamp, '_blank'); // Открываем ссылку в новом окне
      const modalCamps = document.getElementById('modal4');
      modalCamps.classList.remove('is-open'); // Закрываем модальное окно
      const campsContaner = modalCamps.querySelector('.camps-modal-container');
      campsContaner?.classList.remove('active');
    } else {
      iziToast.warning({
        position: 'topRight', 
        message: "Посилання на форму не додано, перевірте будь ласка через деякий час(The link to the form has not been added, please check back after a while)" 
      });
    }
  } else {
    iziToast.warning({
      position: 'topRight',
      message: "Оберіть карточку з кемпом (Choose a card with a camp)", 
      timeout: 3000,
    });
  }
});
})


//* Cкрипт для копирования номера айбан по реквизитам
const clipboard = new Clipboard('.donate-modal-icon-copy');
// Обработчик успешного копирования
clipboard.on('success', function (e) {  
  e.clearSelection();
    iziToast.success({
    position: 'topRight',
    message: "IBAN скопійовано (IBAN copied)",
      timeout: 2000
  });

});
// Обработчик ошибки копирования
clipboard.on('error', function(e) {
  console.error('Ошибка при копировании: ', e);
});

//* Cкрипт для отображения доп инфо по реквизитам при клике
  const itemsDonate = document.querySelectorAll('.donate-info-container');
  const isMobileOrTablet = window.matchMedia('(max-width: 768px)').matches;

  if (isMobileOrTablet) {
    itemsDonate.forEach(item => {
      const contentDonate = item.querySelector('.donate-modal-choice-card-info');
      // Функция для раскрытия/сворачивания контента
      const toggleContent = () => {
        if (contentDonate.innerHTML != "") {
        contentDonate.classList.toggle('open');
        };
        }

      // Обработчик клика
      item.addEventListener('click', toggleContent);
    });
}






